import React from 'react';
import { ErrorPage } from '../ErrorPage';

export const Unauthorised: React.FC = () => (
  <ErrorPage
    title='401 Unauthorised'
    message={
      <span>
        You do not have permission to access the Submit for Assessment system. Please raise a Service Request with the
        BTS helpdesk to request permission.
      </span>
    }
  />
);
